export const VENAQQI_HISTORY_BASE = "venaqqi-base";
export const VENAQQI_HISTORY_GUARD = "venaqqi-guard";

export const seedNavigationGuard = (historyObject = window.history) => {
  if (!historyObject?.replaceState || !historyObject?.pushState) return false;
  const current = historyObject.state && typeof historyObject.state === "object" ? historyObject.state : {};
  historyObject.replaceState({ ...current, venaqqi: VENAQQI_HISTORY_BASE }, "");
  historyObject.pushState({ venaqqi: VENAQQI_HISTORY_GUARD }, "");
  return true;
};

export const pushNavigationLayer = (layer, historyObject = window.history) => {
  if (!layer || !historyObject?.pushState) return false;
  historyObject.pushState({ venaqqi: VENAQQI_HISTORY_GUARD, layer }, "");
  return true;
};
